export default {
  primary: {
    color: 'light',
    backgroundColor: 'secondary',
    opacity: '0.9',
    padding: '1.25rem 2rem',
    border: '2px solid',
    borderColor: 'primary',
    transition: 'all ease-in-out 0.3s',
    fontFamily: 'heading',
    fontWeight: 'normal',
    ':hover': {
      backgroundColor: 'transparent'
    }
  },
  secondary: {
    color: 'light',
    backgroundColor: 'secondary',
    padding: '1.25rem 2rem',
    borderRadius: '160px',
    clipPath: 'polygon(0 5%, 100% 5%, 100% 95%, 0 95%)',
    border: 'none',
    transition: 'all ease-in-out 0.3s',
    ':hover': {
      backgroundColor: 'dark'
    }
  }
}
